import create from 'zustand'

export const useProjectRecentlyState = create((set) => ({
    projects: [],
    addProject: (projectsNew: []) => set((state:any) => {
        return { ...state, projects:projectsNew}
    }),
    
}))